/* eslint no-restricted-globals:0 */
import wasmFile from './wasm/simple_cra_wasm_bg.wasm';
import {Errors, Warnings} from './Messages';
import {CONSTANTS, DBIndexesEnum, LivelliConoscenzaEnum} from './Constants';
import _ from 'lodash';
// Add shim for getAll, used for older versions of Edge and Safari
import "indexeddb-getall-shim";
import {getConcorsiDbPromise, removeStats, getAllQuizzes} from "./DBOperations";
import * as DBOperations from './DBOperations';
import {CONCORSO_OR_PERCORSO} from "@/lib/ConcorsandoWasm/Constants";
import {computeIdDomandaConcorso, computeIdDomandaPercorso} from "@/lib/utils";

/**
 * Initializes the globals expected by simple_cra_wasm.js
 */
function initializeGlobal() {
  Object.defineProperty(self, 'protectedDateNow', {value: Object.freeze(Date.now)});
  const getRandomBytes = () => {
    let r_bytes = new Uint8Array(4);
    return crypto.getRandomValues(r_bytes);
  };
  Object.defineProperty(self, 'protectedGetRandomBytes', {value: Object.freeze(getRandomBytes)});
}

initializeGlobal();

/* Require the module generated by wasm-pack.
 * This will use the global we defined earlier and define a global wasm_bindgen which contains the WASM exported
 * functions. The module still needs to be instantiated, see the function moduleLoadWasm.
 */
require('./wasm/simple_cra_wasm');

const moduleState = {};

/* eslint-disable */
async function _moduleLoadWasm() {
  try {
    const wasm = self.wasm_bindgen;
    // Load and instantiate the wasm module by passing it the path to the wasm file.
    await wasm(wasmFile);
    moduleState.wasm = wasm;
    const res = wasm.init();
    if (res) {
      return res;
    }
    return true;
  } catch (e) {
    throw e;
  }
}

export function moduleLoadWasm() {
  if (!moduleState.wasmPromise) {
    moduleState.wasmPromise = _moduleLoadWasm()
      .catch(e => {
        moduleState.wasmPromise = undefined;
        return Promise.reject(e);
      });
  }
  return moduleState.wasmPromise;
}

export async function moduleInitConcorso(data) {
  try {
    moduleState.concorso = moduleState.wasm.Concorso.new(data);
    return true;
  } catch (e) {
    throw e;
  }
}

export async function moduleInitEsercitazione() {
  try {
    moduleState.concorso.init_esercitazione();
    return true;
  } catch (e) {
    throw e;
  }
}

export async function moduleLoadConcorso(data) {
  if (moduleState.concorso) {
    moduleState.concorso.load(data);
    return true
  }
  else {
    return moduleInitConcorso(data);
  }
}

export async function moduleCloseConcorso() {
  moduleState.concorso.close();
  return true
}

/* eslint-enable */

export async function moduleGetAll() {
  return moduleState.concorso.get_all();
}

export async function moduleGetFirst() {
  const res = await moduleState.concorso.get_first();
  if (res !== "failure") {
    return JSON.stringify([JSON.parse(res)]);
  }
  return res;
}

export async function moduleGetMaterie() {
  return moduleState.concorso.get_materie()
}

export async function moduleGetArgomenti() {
  return moduleState.concorso.get_argomenti();
}

export async function moduleGetByArgomento(argomento) {
  return moduleState.concorso.get_by_argomento(argomento)
}

export async function moduleGetByMateria(materia) {
  return moduleState.concorso.get_by_materia(materia)
}

export async function moduleGetDomande(_query) {
  return moduleState.concorso.get_domande();
}

export async function moduleGetDomandeStampa() {
  return moduleState.concorso.get_domande_stampa();
}

export async function moduleSearchDomande(query, mode, filter_by_spiegazione) {
  return moduleState.concorso.search_domande(query, !!mode, filter_by_spiegazione)
}

export async function moduleGetDomandeQuiz(ids) {
  return moduleState.concorso.get_domande_quiz(ids);
}

export async function moduleSearchDomandeByIds(ids) {
  return moduleState.concorso.search_domande_by_ids(ids);
}

export async function moduleGetRisposteGettonate(g_map) {
  return moduleState.concorso.get_risposte_gettonate(g_map);
}

export async function moduleComputeHash(input) {
  return moduleState.wasm.compute_hash(input);
}

export async function initConcorso(storeName = CONSTANTS.CONCORSI_STORE, id_concorso) {
  const db = await getConcorsiDbPromise();
  try {
    const concorso = await db.get(storeName, id_concorso);
    if (concorso) {
      return moduleLoadConcorso(concorso[CONSTANTS.CONCORSI_DATA_KEY]);
    } else {
      throw {error: {code: Errors.CONCORSO_NON_TROVATO}};
    }
  }
  finally {
    db.close();
  }
}

/* START concorsi db methods */
/**
 *
 * @param {"CONCORSO" | "PERCORSO"} type
 */
async function getAllMeta(type) {
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    return _getAllMeta(CONSTANTS.PERCORSI_META);
  }
  else {
    return _getAllMeta(CONSTANTS.CONCORSI_META);
  }
}
/**
 * @returns {Promise<ConcorsoMeta[]>}
 */
async function _getAllMeta(metaStoreName = CONSTANTS.CONCORSI_META) {
  const db = await getConcorsiDbPromise();
  try {
    return db.getAll(metaStoreName);
  }
  finally {
    db.close();
  }
}

/**
 *
 * @param {"CONCORSO"|"PERCORSO"} type
 */
async function getAllKeys(type) {
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    return _getAllKeys(CONSTANTS.PERCORSI_STORE);
  }
  else {
    return _getAllKeys(CONSTANTS.CONCORSI_STORE);
  }
}

async function _getAllKeys(dataStoreName = CONSTANTS.CONCORSI_STORE) {
  const db = await getConcorsiDbPromise()
  try {
    return db.getAllKeys(dataStoreName);
  }
  finally {
    db.close();
  }
}

/**
 * @param {string} id_concorso
 * @param {"CONCORSO"|"PERCORSO"} type
 * @returns {Promise<ConcorsoMeta>}
 */
async function getMeta(id_concorso, type) {
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    return _getMeta(id_concorso, CONSTANTS.PERCORSI_META);
  }
  else {
    return _getMeta(id_concorso, CONSTANTS.CONCORSI_META);
  }
}

async function _getMeta(id_concorso, metaStoreName = CONSTANTS.CONCORSI_META) {
  const db = await getConcorsiDbPromise();
  try {
    return db.get(metaStoreName, id_concorso)
  }
  finally {
    db.close();
  }
}

async function getAllStats(id_concorso, storeName = CONSTANTS.STATISTICHE_STORE) {
  return getAllQuizzes(storeName, id_concorso);
}

async function updateConcorsoAssegnate(id_concorso) {
  return DBOperations.updateConcorsoAssegnate(id_concorso);
}

/**
 *
 * @param {string} id_concorso
 * @param {Uint8Array} concorso
 * @param {Date} [date]
 * @param {"CONCORSO" | "PERCORSO"} type
 */
async function addConcorso(id_concorso, concorso, date, type = CONCORSO_OR_PERCORSO.CONCORSO) {
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    return _addConcorso(id_concorso, concorso, date, CONSTANTS.PERCORSI_KEY, CONSTANTS.CONCORSI_DATA_KEY, CONSTANTS.PERCORSI_STORE, CONSTANTS.PERCORSI_META, CONSTANTS.PERCORSI_STATISTICHE_STORE, CONSTANTS.PERCORSI_MATERIA_KEY, computeIdDomandaPercorso, CONSTANTS.PERCORSI_DEFAULT_SORT_KEY)
  }
  else {
    return _addConcorso(id_concorso, concorso, date, CONSTANTS.CONCORSI_KEY, CONSTANTS.CONCORSI_DATA_KEY, CONSTANTS.CONCORSI_STORE, CONSTANTS.CONCORSI_META, CONSTANTS.STATISTICHE_STORE, CONSTANTS.CONCORSI_MATERIA_KEY, computeIdDomandaConcorso, CONSTANTS.CONCORSI_DEFAULT_SORT_KEY)
  }
}

/**
 * 
 * @param {string} id_concorso 
 * @param {Uint8Array} concorso
 * @param {Date} [date]
 */
async function _addConcorso(
  id_concorso,
  concorso,
  date,
  concorsiKey = CONSTANTS.CONCORSI_KEY,
  concorsiDataKey = CONSTANTS.CONCORSI_DATA_KEY,
  dataStoreName = CONSTANTS.CONCORSI_STORE,
  metaStoreName = CONSTANTS.CONCORSI_META,
  statsStoreName = CONSTANTS.STATISTICHE_STORE,
  materiaKey = CONSTANTS.CONCORSI_MATERIA_KEY,
  computeIdDomanda = computeIdDomandaConcorso,
  defaultStatsSortKey = CONSTANTS.CONCORSI_DEFAULT_SORT_KEY
) {
  /**
   * @typedef {Object} ConcorsoMeta
   * @property {string} [id_concorso] l'id utilizzato nel caso dei concorsi
   * @property {string} [id_argomento] l'id utilizzato nel caso dei percorsi
   * @property {Date} data_ultimo_aggiornamento
   * @property {number} n_domande - numero totale di domande, incluse quelle senza risposta
   * @property {number} n_domande_con_risposta - il numero di domande che hanno una risposta esatta alla fonte, calcolato solo all'add di un concorso
   * @property {number} n_domande_assegnate - il numero di domande assegnate da noi, variabile
   * @property {Object.<string, number>} n_domande_by_materia - n. di domande per materia (in caso dei percorsi sono per sottopercorso), variabile
   * @property {Object.<string, number>} n_domande_by_materia_orig - n. di domande per materia (in caso dei percorsi sono per sottopercorso), costante
   * @property {Object.<string, number>} n_domande_senza_risposta_by_materia - (DA IGNORARE NEI PERCORSI) n. di domande che non hanno una risposta esatta nella banca dati
   * @property {Object.<string, number>} n_domande_assegnate_by_materia - (DA IGNORARE NEI PERCORSI) n. di domande per materia a cui è stata assegnata da noi una risposta, variabile
   */
  /**
   * @type {ConcorsoMeta}
   */
  const meta = {[concorsiKey]: id_concorso};
  const payload = {
    [concorsiKey]: id_concorso,
    [concorsiDataKey]: concorso
  };

  // Questo cambia il concorso attualmente caricato in ram
  await moduleLoadConcorso(concorso);
  /**
   * @typedef {Object} Domanda
   * @property {number} id
   * @property {string} id_argomento
   * @property {Array<{value: string, id: string}>} sotto_argomenti
   * @property {string} id_concorso
   * @property {string} id_materia
   * @property {string} indice_uff
   * @property {string} id_risposta_esatta
   * @property {boolean} has_image
   * @property {string} domanda
   */
  /**
   * @type {Array<Domanda>}
   */
  let domande;
  try {
    domande = JSON.parse(moduleState.concorso.get_domande());
    meta.n_domande = domande.length;
    const domandeConRisposta = domande.filter(x => _.get(x,"id_risposta_esatta", "0") !== "0")
    meta.n_domande_con_risposta = domandeConRisposta.length;
    meta.n_domande_assegnate = 0;
    if (date)
      meta.data_ultimo_aggiornamento = date;
    meta.n_domande_by_materia =
      _.chain(domandeConRisposta)
        .groupBy(materiaKey)
        .mapValues(v => Array.isArray(v) && v.length)
        .value();
    meta.n_domande_by_materia_orig = {...meta.n_domande_by_materia};
    meta.n_domande_senza_risposta_by_materia =
      _.chain(domande)
        .filter(x => _.get(x,"id_risposta_esatta", "0") === "0")
        .groupBy("id_materia")
        .mapValues(v => Array.isArray(v) && v.length) // All'inizio non ci saranno risposte gettonate
        .value();
    meta.n_domande_assegnate_by_materia = _.mapValues(meta.n_domande_senza_risposta_by_materia, () => 0)
  }
  catch (e) {
    // Nothing
  }

  /**
   * @typedef {Object} StatsDomanda
   * @property {string} id_concorso
   * @property {string} id_domanda,
   * @property {string} id_materia,
   * @property {string} id_argomento,
   * @property {string} id_sotto_percorso,
   * @property {string} id_simulazione,
   * @property {number} preferiti - 0 se false, 1 se true
   * @property {LivelliConoscenzaEnum} livello_conoscenza,
   * @property {number} risposta_gettonata,
   * @property {number} risposta,
   * @property {"LETTA" | "ASCOLTATA" | "ESEGUITA"} modalita,
   * @property {Date} data_letta,
   * @property {Date} data_ascoltata,
   * @property {Date} data_eseguita,
   * @property {number | undefined} sincronizzata - 0 o 1 se l'utente l'ha mai modificata, altrimenti undefined
   * @property {boolean} has_image,
   * @property {number} has_risposta, 0 o 1 per false e true rispettivamente
   * @property {number} indice_uff,
   * @property {boolean} [isPreferitiUpdated] valore temporaneo per capire se forzare o meno l'incremento del contatore
   * @property {boolean} [isLevelUpdated] valore temporaneo per capire se forzare o meno l'incremento del contatore
   */
  /**
   * @type {Array<StatsDomanda>}
   */
  let statsMap;
  if (domande) {
    // We just set the fields that we are going to use
    statsMap = {};

    _.chain(domande)
      .sortBy([defaultStatsSortKey])
      .value()
      .forEach((d, i) => {
        const id_domanda = computeIdDomanda(d);
        statsMap[id_domanda] = {
          id_concorso: d.id_concorso,
          id_materia: d.id_materia,
          id_domanda: id_domanda,
          id_sotto_percorso: d.id_sotto_percorso,
          id_argomento: d.id_argomento,
          preferiti: 0,
          livello_conoscenza: LivelliConoscenzaEnum.NON_RISPOSTE,
          modalita: "ESEGUITA",
          sincronizzata: undefined, // -> Rimosso perché le statistiche di default non le consideriamo neanche ai fini della sincronizzazione
          has_image: d.has_image,
          indice_uff: i,
          has_risposta: _.get(d, "id_risposta_esatta", "0") === "0" ? 0 : 1,
        };
      })
  }

  const db = await getConcorsiDbPromise();
  
  try {

    const tx = db.transaction([dataStoreName, metaStoreName, statsStoreName], 'readwrite');

    const statsStore = tx.objectStore(statsStoreName);

    // Merging the statsMap
    const ix_concorso = statsStore.index(DBIndexesEnum.BY_CONCORSO);
    let cursor = await ix_concorso.openCursor(IDBKeyRange.only(id_concorso));
    while (cursor) {
      /** @type {StatsDomanda} */
      let quizStats = cursor.value;
      if (statsMap[quizStats.id_domanda]) {
        /* Campi da aggiornare:
         *  - id_materia
         *  - has_image
         *  - has_risposta
         *  - indice_uff
         *  - id_sotto_percorso
         *
         * In generale aggiornare tutti i campi che vengono calcolati dal WASM.
         */
        const fieldsToKeep = _.pick(statsMap[quizStats.id_domanda], ['id_materia', 'has_image', 'has_risposta', 'indice_uff', 'id_sotto_percorso']);
        statsMap[quizStats.id_domanda] = {...quizStats, ...fieldsToKeep};

        if ( // Aggiorniamo anche i metadati in locale se già presenti delle statistiche
          quizStats.has_risposta === 1
          && quizStats.risposta_gettonata
        ) {
          // Aggiungiamo una domanda alle risposte assegnate per materia
          if (meta.n_domande_assegnate_by_materia[quizStats.id_materia] != undefined) {
            meta.n_domande_assegnate_by_materia[quizStats.id_materia] += 1;
          } else {
            meta.n_domande_assegnate_by_materia[quizStats.id_materia] = 1;
          }
          // Aggiungiamo una domanda alle domande con risposta per materia
          if (meta.n_domande_by_materia[quizStats.id_materia] != undefined) {
            meta.n_domande_by_materia[quizStats.id_materia] += 1;
          } else {
            meta.n_domande_by_materia[quizStats.id_materia] = 1;
          }
          meta.n_domande_assegnate += 1;
        }
      }
      cursor = await cursor.continue()
    }

    // Removing old stats
    await removeStats(statsStoreName, id_concorso, undefined, {transaction: tx});

    // statsMap -> stats array
    let stats;
    if (statsMap) {
      stats = Object.values(statsMap).flatMap(x => x);
    }

    // Save new stats
    await Promise.all(stats.map(s => statsStore.add(s)));

    return await Promise.all([
      tx.objectStore(dataStoreName).put(payload),
      tx.objectStore(metaStoreName).put(meta),
      tx.done
    ])
  }
  catch(e) {
    let error;
    if (e instanceof DOMException && e.name === "QuotaExceededError") {
      error = {error: {code: Errors.INDEXEDDB_NOT_ENOUGH_SPACE}}
    }
    else {
      /* NOTE: Errors of type DOMException cannot be passed back with self.postMessage,
       * so we at least log them to console.
       */
      console.error(e);
      error = {error: {code: Errors.INDEXEDDB_GENERIC_ERROR}}
    }
    throw error;
  }
  finally {
    db.close()
  }
}

/**
 *
 * @param {string} id_concorso
 * @param {"CONCORSO" | "PERCORSO"} type
 */
async function delConcorso(id_concorso, type) {
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    return _delConcorso(id_concorso, CONSTANTS.PERCORSI_STORE, CONSTANTS.PERCORSI_META, CONSTANTS.PERCORSI_STATISTICHE_STORE)
  }
  else {
    return _delConcorso(id_concorso, CONSTANTS.CONCORSI_STORE, CONSTANTS.CONCORSI_META, CONSTANTS.STATISTICHE_STORE)
  }
}

async function _delConcorso(id_concorso, dataStoreName = CONSTANTS.CONCORSI_STORE, metaStoreName = CONSTANTS.CONCORSI_META, statsStoreName = CONSTANTS.STATISTICHE_STORE) {
  const db = await getConcorsiDbPromise();

  const tx = db.transaction([dataStoreName, metaStoreName, statsStoreName], 'readwrite');

  try {
    return await Promise.all([
      tx.objectStore(dataStoreName).delete(id_concorso),
      tx.objectStore(metaStoreName).delete(id_concorso),
      removeStats(statsStoreName, id_concorso, undefined, {transaction: tx}),
      tx.done,
    ])
  }
  catch(e) {
    console.error(e);
    throw {error: {code: Errors.INDEXEDDB_GENERIC_ERROR}}
  }
  finally {
    db.close()
  }
}

/**
 * Ripulisce dal db locale i concorsi non più utilizzati dall'utente.
 *
 * Pre-condizioni:
 *  - gli store sono sincronizzati, in particolare se uno dei database dataStore e statsStore contiene un riferimento a
 *    un concorso, allora quel concorso è presente in metaStore
 *
 * In particolare per decidere se esiste un concorso da eliminare è sufficiente guardare metaStore.
 *
 * @param {string[]} user_concorso_ids
 * @param {"CONCORSO" | "PERCORSO"} type
 * @returns {Promise<void>}
 */
async function clearConcorsi(user_concorso_ids, type) {
  const meta = await getAllMeta(type);

  /**
   * @type {string[]}
   */
  let cur_ids = [];
  if (type === CONCORSO_OR_PERCORSO.PERCORSO) {
    cur_ids = meta.map(x => x.id_argomento);
  }
  else {
    cur_ids = meta.map(x => x.id_concorso);
  }

  const ids_to_remove = _.difference(cur_ids, user_concorso_ids);

  for(let concorso_id of ids_to_remove) {
    await delConcorso(concorso_id, type)
  }
}

export const concorsiDb = {
  getAllMeta,
  getAllKeys,
  getMeta,
  addConcorso,
  delConcorso,
}

function _wrapWithError(fn, code) {
  return async function(...args) {
    try {
      return await fn(...args)
    } 
    catch(e) {
      if (e && e.error && e.error.code && Object.keys(Errors).includes(e.error.code)) {
        throw e
      }
      else {
        console.error(e);
        throw {error: {code}}
      }
    }
  }
}

/* END concorsi db methods */

async function checkQuota() {
  if (navigator.storage && navigator.storage.estimate) {
    const quota = await navigator.storage.estimate();

    const usage = (quota.usage / quota.quota);

    if (usage >= 0.95) {
      return {quota, warning: Warnings.INDEXEDDB_LOW_SPACE}
    }
    else {
      return {quota}
    }
  }
}

const USE_OBJECT_RETURN = ["moduleGetDomandeQuiz", "moduleComputeHash"];

self.onmessage = (evt) => {
  let {type, args = [], id} = evt.data;
  let cb = () => Promise.resolve(true);
  // eslint-disable-next-line no-unused-vars
  let resField = "default";
  let options = { sliceRes: false };
  switch(type) {
    case 'moduleLoadWasm':
      cb = moduleLoadWasm;
      resField = "init";
      break;
    case 'moduleGetAll':
      cb = moduleGetAll;
      resField = "domande";
      options.sliceRes = true;
      break;
    case 'moduleGetFirst':
      cb = moduleGetFirst;
      resField = "domande";
      break;
    case 'moduleGetMaterie':
      cb = moduleGetMaterie;
      resField = "materie";
      break;
    case 'moduleGetArgomenti':
      cb = moduleGetArgomenti;
      resField = "argomenti";
      break;
    case 'moduleGetByArgomento':
      cb = moduleGetByArgomento;
      resField = "domande";
      break;
    case 'moduleGetByMateria':
      cb = moduleGetByMateria;
      resField = "domande";
      break;
    case 'moduleGetDomande':
      cb = moduleGetDomande;
      break;
    case 'moduleGetDomandeStampa':
      cb = moduleGetDomandeStampa;
      break;
    case 'moduleInitConcorso':
      cb = moduleInitConcorso;
      resField = "concorso";
      break;
    case 'moduleInitEsercitazione':
      cb = moduleInitEsercitazione;
      break;
    case 'moduleSearchDomande':
      cb = moduleSearchDomande;
      break;
    case 'moduleGetDomandeQuiz':
      cb = moduleGetDomandeQuiz;
      break;
    case 'moduleSearchDomandeByIds':
      cb = moduleSearchDomandeByIds;
      break;
    case 'moduleGetRisposteGettonate':
      cb = moduleGetRisposteGettonate;
      break;
    case 'moduleComputeHash':
      cb = moduleComputeHash;
      break;
    case 'initConcorso':
      cb = initConcorso;
      break;
    case 'getAllMeta':
      cb = _wrapWithError(getAllMeta, Errors.INDEXEDDB_GENERIC_ERROR);
      break;
    case 'getAllKeys':
      cb = _wrapWithError(getAllKeys, Errors.INDEXEDDB_GENERIC_ERROR);
      break;
    case 'getMeta':
      cb = _wrapWithError(getMeta, Errors.INDEXEDDB_GENERIC_ERROR);
      break;
    case 'addConcorso':
      cb = addConcorso;
      break;
    case 'getAllStats':
      cb = getAllStats;
      break;
    case 'delConcorso':
      cb = delConcorso;
      break;
    case 'clearConcorsi':
      cb = clearConcorsi;
      break;
    case 'getQuota':
      cb = checkQuota;
      break;
    case 'updateConcorsoAssegnate':
      cb = updateConcorsoAssegnate;
      break;
  }
  if (USE_OBJECT_RETURN.includes(type)) {
    cb(...args)
      .then(parsedRes => {
        // wasm_bindgen already took care of parsing the JSON here
        const result = _.get(parsedRes, "result");
        if (result === "OK") {
          const msg = {
            result: _.get(parsedRes, "data"),
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg)
        } else if (result === "KO") {
          const err = _.get(parsedRes, "error");
          const msg = {
            error: err,
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg);
          return Promise.reject({err, alreadyPosted: true});
        } else {
          const err = new Error("Uknown Error");
          const msg = {
            error: err,
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg);
          return Promise.reject({err, alreadyPosted: true});
        }
      })
      .catch((e = {}) => {
        const {alreadyPosted, error} = e;
        if (!alreadyPosted) {
          const msg = {
            error: error || e,
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg);
        }
      });
    return;
  }
  cb(...args)
      .then(res => {
        if (res === "failure") {
          const err = new Error("failed");
          const msg = {
            error: err,
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg);
          return Promise.reject({err, alreadyPosted: true});
        }
        return res;
      })
      .then(res => options.sliceRes ? JSON.stringify(JSON.parse(res).slice(0,100)) : res)
      .then((res) => {
        const msg = {
          result: res,
          _originalRequest: evt.data,
          id,
        }
        self.postMessage(msg)
      })
      .catch((e = {}) => {
        const {alreadyPosted, error} = e;
        if (!alreadyPosted) {
          const msg = {
            error: error || e,
            _originalRequest: evt.data,
            id,
          }
          self.postMessage(msg);
        }
      })
      // .finally(() => self.postMessage({type: "finally"}))
}
